export enum AddDocumentTypeEnum {
  FromDocumentMinotaure = 1,
  FromLocalFolder = 2,
}
